import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrending = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.3 4.10234L18.425 2.60469C18.7063 2.225 19.1562 2 19.6273 2C20.45 2 21.125 2.675 21.125 3.49766V5.05859C21.125 5.97969 21.5047 6.86562 22.1727 7.49844L28.1281 13.1797C31.5594 16.4563 33.5 20.9984 33.5 25.7445C33.5 32.5156 28.0156 38 21.2445 38H20C12.5469 38 6.5 31.9531 6.5 24.5V24.2328C6.5 20.8016 7.86406 17.5109 10.2898 15.0852L10.5359 14.8391C10.8313 14.5438 11.2391 14.375 11.6609 14.375C12.5398 14.375 13.25 15.0852 13.25 15.9641V22.25C13.25 24.732 15.268 26.75 17.75 26.75C20.232 26.75 22.25 24.732 22.25 22.25V21.9758C22.25 20.7102 21.7438 19.4937 20.8508 18.6008L18.1367 15.8867C16.4492 14.1992 15.5 11.9 15.5 9.50938C15.5 7.56172 16.1328 5.65625 17.3 4.10234Z" })
});
export default SvgTrending;
